// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import { cardListHeadingStyles } from "@guestsupply/Overrides/Components/CardListHeading";
import CaretRight from "@guestsupply/XDL/Icons/CaretRight";
import { color, createLinkIconStyles } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

cardListHeadingStyles.containerGridItem = {
    width: 12,
    css: css`
        padding: 20px 10px;
    `,
};

cardListHeadingStyles.containerWrapper = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid ${color("common.border")};
        padding-top: 40px;
    `,
};

cardListHeadingStyles.viewAllStyles = {
    ...createLinkIconStyles(CaretRight, {
        icon: {
            iconProps: {
                size: 12,
            },
        },
        css: css`
            margin-left: auto;
            margin-top: 5px;
        `,
    }),
};
